import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { SocketProvider } from "./hooks/useSocket";
import { useStore } from "./context/StoreContext";
import Products from "./pages/products/Products";

import LaamLayout from "./pages/Laam/LaamLayout";
import Laam from "./pages/Laam/Laam";
import LaamProducts from "./pages/Laam/LMProducts";
import ProductsDLM from "./pages/Laam/ProductsDLM";
import LaamOrders from "./pages/Laam/LMOrders";
import OrdersDLM from "./pages/Laam/OrdersDLM";
import ProductDetails from "./pages/products/ProductDetails";

import DGOrders from "./pages/Laam/DGOrders";
import DGOrderDetail from "./pages/Laam/DGOrderDetail";

import OrdersLayout from "./components/orders/OrdersLayout";
import Orders from "./pages/orders/Orders";
import OrdersBooking from "./pages/orders/OrdersBooking";
import OrdersProcessing from "./pages/orders/OrdersProcessing";
import OrdersPaid from "./pages/orders/OrdersPay";

import Dashboard from "./Dashboard";
import Login from "./pages/auth/LoginPage";
import UserRegister from "./pages/auth/SignUp";
import Users from "./pages/auth/Users";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Logs from "./pages/system/Logs";

// import TraxCity from "./pages/CitiesTable";
import OrderDetails from "./pages/orders/OrderDetails";
import Stores from "./pages/stores/Stores";
import StoresDetails from "./pages/stores/StoreDetails";
import StoreSaleReports from "./pages/stores/StoreSaleReports";
import Couriers from "./pages/couriers/Couriers";
import LoadSheet from "./pages/orders/LoadSheet";
import CourierDetails from "./pages/couriers/CourierDetails";
import Webhooks from "./pages/system/Webhooks";
import InventoryLogs from "./pages/inventory/InventoryLogs";
import VariantDetails from "./pages/products/VariantDetails";
import ConnectShopify from "./pages/stores/ConnectShopify";
import Charts from "./pages/analytics/Charts";
import ChatHome from "./pages/chat/ChatHome";
const isAuthenticated = () => {
  // You can replace this with your token check logic
  return localStorage.getItem("token") !== null;
};

// Private route component
function PrivateRoute({ element, ...rest }) {
  return isAuthenticated() ? element : <Navigate to="/login" />;
}
const getUserRole = () => {
  // This is an example; you would typically parse the token or get this data from an API
  const user = JSON.parse(localStorage.getItem("user"));

  return user?.user.role; // Example: 'admin', 'orders', 'user', etc.
};
function RoleBasedRoute({ element, allowedRoles, ...rest }) {
  const userRole = getUserRole();

  return isAuthenticated() && allowedRoles.includes(userRole) ? (
    element
  ) : (
    <Navigate to="/login" />
  );
}

function App() {
  const { selectedStore, isStoreSelected } = useStore();
  const storeID = isStoreSelected && selectedStore.id;
  return (
    <SocketProvider storeId={storeID}>
      <Router>
        <Routes>
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />}>
            <Route
              path="/products"
              element={<PrivateRoute element={<Products />} />}
            ></Route>
            <Route
              path="/chart"
              element={<PrivateRoute element={<Charts />} />}
            ></Route>
            <Route
              path="/product/:id"
              element={<PrivateRoute element={<ProductDetails />} />}
            ></Route>

            <Route
              path="/variant/:sku"
              element={<PrivateRoute element={<VariantDetails />} />}
            ></Route>
            <Route
              path="/webhooks"
              element={<PrivateRoute element={<Webhooks />} />}
            ></Route>

            <Route
              path="/inventoryLogs"
              element={<PrivateRoute element={<InventoryLogs />} />}
            ></Route>
            <Route
              path="/logs"
              element={<PrivateRoute element={<Logs />} />}
            ></Route>
            <Route
              path="/stores"
              element={<PrivateRoute element={<Stores />} />}
            ></Route>
            <Route
              path="/stores/:id"
              element={<PrivateRoute element={<StoresDetails />} />}
            ></Route>
            <Route
              path="/couriers"
              element={<PrivateRoute element={<Couriers />} />}
            ></Route>
            <Route
              path="/loadsheet"
              element={<PrivateRoute element={<LoadSheet />} />}
            ></Route>
            <Route
              path="/courierdetails/:id"
              element={<PrivateRoute element={<CourierDetails />} />}
            ></Route>

            <Route
              path="/salereports/:id"
              element={<PrivateRoute element={<StoreSaleReports />} />}
            ></Route>

            <Route
              path="/orders"
              element={<PrivateRoute element={<OrdersLayout />} />}
            >
              <Route index element={<Orders />} />
              <Route path=":id" element={<OrderDetails />} />
              <Route path="processing" element={<OrdersProcessing />} />
              <Route path="booking" element={<OrdersBooking />} />
              <Route path="paid" element={<OrdersPaid />} />
            </Route>
            <Route
              path="/laam"
              element={<PrivateRoute element={<LaamLayout />} />}
            >
              <Route index element={<Navigate to="/laam/products" />} />
              <Route path="/laam/products" element={<LaamProducts />} />
              <Route path="/laam/products/:id" element={<ProductsDLM />} />
              <Route path="/laam/orders" element={<LaamOrders />} />
              <Route path="/laam/dg/orders" element={<DGOrders />} />
              <Route path="/laam/orders/:id" element={<OrdersDLM />} />
            </Route>
            <Route
              path="/dg/orders/:id"
              element={<PrivateRoute element={<DGOrderDetail />} />}
            />
            <Route
              path="/chats"
              element={<PrivateRoute element={<ChatHome />} />}
            ></Route>
          </Route>

          <Route>
            <Route path="/signup" element={<UserRegister />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/users" element={<Users />} />
          </Route>
          <Route>
            <Route path="/shopify/connect" element={<ConnectShopify />} />
          </Route>
        </Routes>
      </Router>
    </SocketProvider>
  );
}

export default App;
